<template>
  <lm-help-tip
    v-if="relatedActors.length > 0"
    class="RelatedActors"
    icon="link"
  >
    <h1 class="RelatedActors-title">Related actors</h1>
    <router-link
      v-for="actor in relatedActors"
      :key="actor.id"
      class="RelatedActors-label"
      tag="span"
      :to="{params: {actor: actor.pathArr}, query: $route.query}"
    >
      <lm-actor-circle class="mr-3" :color="actor.color" />
      {{ actor.name }}
    </router-link>
  </lm-help-tip>
</template>

<script>
import {mapGetters} from 'vuex'
import LmHelpTip from '@/components/ui/LmHelpTip'
import LmActorCircle from '@/components/ui/misc/LmActorCircle'
export default {
  name: 'RelatedActors',
  components: {LmActorCircle, LmHelpTip},
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getActors']),
    relatedActors() {
      return this.topic.relatedActors
        .map(id => this.getActors[id])
        .filter(actor => !!actor) // remove broken refs
    }
  }
}
</script>

<style scoped>
.RelatedActors {
  &-title {
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 1;
    text-transform: uppercase;
  }
  &-label {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
